// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  note: {
    fontSize: '11px',
    color: '#8a94a0',
  },
  noteMissing: {
    fontSize: '11px',
    color: '#b26a00',
  },
  noteResolving: {
    fontSize: '11px',
    color: '#8a94a0',
    fontStyle: 'italic',
  },
  infoIcon: {
    fontSize: 14,
    color: '#8a94a0',
    flexShrink: 0,
  },
  // Shrinks the IconButton's default padding so a 14px icon doesn't turn into a 40px tap target
  // that throws off the header row's spacing.
  infoIconButton: {
    padding: '2px',
  },
  tooltip: {
    // Wider than the MUI default: room for a couple of concise sentences without wrapping oddly.
    '& .MuiTooltip-tooltip': {
      maxWidth: 280,
      backgroundColor: '#0f2136',
      padding: theme.spacing(1.5),
      fontSize: '12px',
      lineHeight: 1.45,
    },
  },
});

export default styles;
